import dynamicRoutes from './__zn__dynamic-route'

export default [
  ...dynamicRoutes
]
